import { useState, useEffect } from "react";

// Stato che sopravvive alla navigazione: salvato in localStorage finché non viene resettato.
export default function usePersistedState(key, initial) {
  const [val, setVal] = useState(() => {
    try {
      const raw = localStorage.getItem("flt." + key);
      return raw !== null ? JSON.parse(raw) : initial;
    } catch (_) {
      return initial;
    }
  });
  useEffect(() => {
    try { localStorage.setItem("flt." + key, JSON.stringify(val)); } catch (_) {}
  }, [key, val]);
  return [val, setVal];
}

export function clearPersisted(prefix) {
  try {
    Object.keys(localStorage)
      .filter((k) => k.startsWith("flt." + prefix))
      .forEach((k) => localStorage.removeItem(k));
  } catch (_) {}
}
